import axios from 'axios'

import * as common from '@bfg/common'

/**
 * Имя GET-параметра, которым валюта форсируется вручную.
 */
export const CURRENCY_PARAM = 'currency'

/**
 * Валюта, принудительно заданная через ?currency=eur.
 *
 * Нужна для проверки: без неё увидеть хотя бы одну не-долларовую страну можно
 * только через VPN, а сто тридцать — никак. Сервер принимает параметр только
 * на стенде и только если у тарифа есть цена в этой валюте, поэтому здесь
 * достаточно проверить форму кода, а не сверяться со списком валют.
 */
export const forcedCurrency = (search) => {
  const raw = new URLSearchParams(
    typeof search === 'string' ? search : window.location.search
  ).get(CURRENCY_PARAM)

  if (raw === null) {
    return null
  }

  const currency = raw.trim().toLowerCase()

  if (!/^[a-z]{3}$/.test(currency)) {
    console.warn(
      `[currency] "${raw}" не похож на трёхбуквенный код валюты в ?${CURRENCY_PARAM}, игнорирую`
    )

    return null
  }

  return currency
}

/**
 * Прокидывает форсированную валюту во все запросы к нашему API.
 *
 * Цена собирается на сервере — и в интерфейсе, и внутри листа кошелька, —
 * поэтому параметр обязан доехать туда. Вместо правки каждого запроса вешаем
 * один интерцептор, как это уже сделано для варианта пейволла.
 *
 * Только наш API: сторонние запросы (ipify, rewardful) трогать незачем.
 */
export const installForcedCurrencyInterceptor = () => {
  const forced = forcedCurrency()

  if (forced === null) {
    return
  }

  axios.interceptors.request.use(config => {
    const url = config.url || ''
    const isOwnApi = common.api === '' ? url.startsWith('/') : url.indexOf(common.api) === 0

    if (isOwnApi) {
      config.params = { ...(config.params || {}), [CURRENCY_PARAM]: forced }
    }

    return config
  })

  console.info(`[currency] валюта принудительно задана через URL: ${forced}`)
}
